import azure from './auth-init';

const {
    AzureProvider,
    initiliazeMsalInstance,
    instance,
    localAuth,
    loginRequest,
    logoutWithoutRedirect,
    msalConfig
} = azure;

export {
    AzureProvider,
    initiliazeMsalInstance,
    instance,
    localAuth,
    loginRequest,
    logoutWithoutRedirect,
    msalConfig
};
